'use client';

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useLayoutEffect } from 'react';
import { getFocusableElements, isFocusable } from '@/app/components/overlays/utils/focusable';
interface UseAutoFocusProps {
  containerRef: RefObject<HTMLElement | null>;
  enabled: boolean;
}

/**
 * Automatically focuses the first focusable element inside the container,
 * or the element with [data-autofocus], or the container itself.
 */
export const useAutoFocus = t0 => {
  const $ = _c(4);
  const {
    containerRef,
    enabled
  } = t0;
  let t1;
  let t2;
  if ($[0] !== containerRef || $[1] !== enabled) {
    t1 = () => {
      if (!enabled || !containerRef.current) {
        return;
      }
      const container = containerRef.current;
      requestAnimationFrame(() => {
        if (!container) {
          return;
        }
        const autoFocusEl = container.querySelector("[data-autofocus]");
        if (autoFocusEl && isFocusable(autoFocusEl)) {
          autoFocusEl.focus({
            preventScroll: true
          });
          return;
        }
        const focusables = getFocusableElements(container);
        if (focusables.length > 0) {
          focusables[0].focus({
            preventScroll: true
          });
          return;
        }
        if (isFocusable(container)) {
          container.focus({
            preventScroll: true
          });
        }
      });
    };
    t2 = [containerRef, enabled];
    $[0] = containerRef;
    $[1] = enabled;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useLayoutEffect(t1, t2);
};